import React, { useEffect, useState } from 'react';
export function Navigation() {
  const [pastVideo, setPastVideo] = useState(false);
  const scrollToVideo = () => {
    document.getElementById('vsl-video')?.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  };
  useEffect(() => {
    const onScroll = () => {
      const video = document.getElementById('vsl-video');
      if (!video) return;
      const rect = video.getBoundingClientRect();
      // Once the bottom of the video has scrolled above the top of the viewport
      setPastVideo(rect.bottom < 80);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);
  return <nav className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-gray-200" data-id="element-115">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-116">
        <div className="flex items-center justify-between h-16" data-id="element-117">
          <div className="flex items-center" data-id="element-118">
            <img src="https://cdn.magicpatterns.com/uploads/2Vc1SybtX5ntsou5rRY33H/NTY-Logo.png" alt="NTY Windows" className="h-10 w-auto" data-id="element-119" />
          </div>

          <div className="flex items-center space-x-4" data-id="element-120">
            <div className="hidden sm:block px-3 py-1 bg-gray-100 rounded-full text-sm font-medium text-gray-700" data-id="element-121">
              Missoula, MT
            </div>
            <button onClick={scrollToVideo} className="px-4 sm:px-6 py-2 bg-maroon text-white text-sm sm:text-base font-semibold rounded hover:bg-opacity-90 transition-colors whitespace-nowrap" data-id="element-122">
              {pastVideo ? 'Finish video to see apply link' : 'Apply Now'}
            </button>
          </div>
        </div>
      </div>
    </nav>;
}